import React, { useState, useEffect } from "react";
// import Cross from "../../../Assets/Img/Group 208.png";
import PersonalInfo from "./Personalinfo";
import { NavLink, useNavigate } from "react-router-dom";
import PostData from "../../../Api/PostData";
import Swal from "sweetalert2";
import "./style.css";
import analytics from "../../../firebase.config";
import { getAnalytics, logEvent } from "firebase/analytics";
import Disclaimer from "../../Atoms/Disclaimer";

const TermAndConditions = ({
  handleDrctChange,
  prevStep,
  nextStep,
  handleChange,
  values,
}) => {
  const [sendingSaveReq, setsendingSaveReq] = useState(false);
  const [error, setError] = useState(false);
  const history = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  var moveToOtpScreenOtpRejected = localStorage.getItem(
    "editFormStatusForReturnOnOtp"
  );
  var editFormStatus = localStorage.getItem("editFormStatus");
  const openSaveExitModel = () => {
    Swal.fire({
      title: "You’re almost there!",
      text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
      icon: "success",
      showCancelButton: true,
      confirmButtonColor: "#e5386a",
      // cancelButtonColor: '#d33',
      cancelButtonText: "Continue",
      // showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: "Exit",
      // denyButtonText: `Don't save`,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    }).then((result) => {
      if (result.isConfirmed == true) {
        if (moveToOtpScreenOtpRejected == "true" || editFormStatus == "true") {
          history("/Otp");
        } else {
          history("/");
        }
      }
    });
    // Get the modal
    // var modal = document.getElementById("SaveExitModal");

    // // Get the <span> element that closes the modal
    // var span = document.getElementsByClassName("close");
    // // When the user clicks the button, open the modal
    // modal.style.display = "block";

    // // When the user clicks on <span> (x) or Close, close the modal

    // for (let i = 0; i < span.length; i++) {
    //   console.log(span, span[i]);
    //   span[i].onclick = function () {
    //     modal.style.display = "none";
    //   };
    // }
    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {
    //   if (event.target == modal) {
    //     modal.style.display = "none";
    //   }
    // };
  };
  const handleBackBtn = () => {
    logEvent(analytics, "aof_t_and_c_press_back");
    handleDrctChange("step", 4);
  };
  const SaveSubmit = () => {
    setsendingSaveReq(true);

    const res = PostData.SaveAndExit(values, setError, false);
    res
      .then((value) => {
        setsendingSaveReq(false);
        if (value.data) {
          openSaveExitModel();
        }
        //   else {
        //     message.error(value.data);
        //   }
      })
      .catch(function (error) {
        setsendingSaveReq(false);
        console.log(error.response);
      });
  };

  const handleAccpet = (e) => {
    e?.preventDefault();
    logEvent(analytics, "aof_t_and_c_press_continue");
    nextStep();
  };

  return (
    <div className="container-fluid px-0 bg-grey-100 py-5">
      <PersonalInfo handleDrctChange={handleDrctChange} values={values} />
      <div className="container px-0">
        <div className="mt80 ">
          <div className="d-inline-flex w-100">
            <h1 className="fs32 ls4 fw-800 t-grey-800 px-3">
              Terms & Conditions
            </h1>
          </div>
        </div>
        <hr className="t-grey-200 mt80"></hr>
        <div className="termsandconditionsscrol px-3">
          <div>
            <div className="d-inline-flex w-100 ">
              <h2>
                E. AUTHORIZATION UNDER SECTIONS 12 AND 24 OF THE CDC ACT
                EXCLUSIVELY FOR SETTLEMENT OF UNDERLYING TRADES, PLEDGE AND
                RECOVERY OF PAYMENTS, CHARGES AND LOSSES (FOR SUB-ACCOUNT ONLY)
              </h2>
            </div>

            <p className=" fs16 t-pink-tc mt">
              I/we the undersigned, hereby give my/our express authority to the
              Participant under Section 12 and Section 24 of the Central
              Depositories Act, 1997 to handle Book-entry Securities
              beneficially owned by me/us and entered in my/our Sub-Account
              maintained with the Participant for securities transactions that
              are exclusively meant for the following purposes:
            </p>
            <p className="fs16 t-pink-tc my-3 mt">
              <ol type="a">
                <li>
                  {" "}
                  For the settlement of any underlying market transactions
                  (trades) including off market transactions made by me/us from
                  time to time; <br />
                </li>
                <li>
                  {" "}
                  For pledge securities transactions with the Clearing House
                  relating to any of my/our underlying market transactions
                  (trades) to be settled through the Clearing House from time to
                  time; <br />
                </li>
                <li>
                  {" "}
                  For the recovery of payment against any underlying market
                  purchase transactions made by me/us from time to time; <br />
                </li>
                <li>
                  {" "}
                  Movement by me/us from time to time of my/our Book-entry
                  Securities from my/our Sub-Account under the Main Account
                  under the control of the Participant to my/our Sub-Account
                  under another Main Account under the control of the
                  Participant or to my/our Sub-Account under any Main Account
                  which is under the control of another Participant or to my/our
                  Investor Account; <br />
                </li>
                <li>
                  {" "}
                  Securities transactions which has been made by way of a gift
                  of Securities by me/us to my/our Family Members or other
                  persons in accordance with the CDC Regulations from time to
                  time; <br />
                </li>
                <li>
                  {" "}
                  For the recovery of any charges or losses against any or all
                  of the above transactions carried out by me/ us or services
                  availed; and/or <br />
                </li>
                <li>
                  {" "}
                  Delivery Transaction made by me/us for any other purposes as
                  prescribed by the Commission from time to time. <br />
                </li>
              </ol>
            </p>
            <p className=" fs16 t-pink-tc my-3 mt">
              Specific authority on each occasion shall be given by me/us to the
              Participant for handling of Book-entry Securities beneficially
              owned by me/us for all other purposes as permitted under the
              applicable laws and regulations.
            </p>
            <p className="fs16 t-pink-tc my-3 mt">
              <b className="Bold">Note:</b> Please note that above shall serve
              as a standing authorization to the Participant for handling of
              Book-entry Securities owned by the undersigned Sub-Account
              Holder(s) and entered in his/her/their Sub-Account maintained with
              the Participant. Handling of Book-entry Securities for all other
              purposes should however require specific authority in writing from
              the undersigned Sub-Account Holder(s) in favor of the Participant.
              For handling of Book-entry Securities worth Rs. 500,000/- and
              above, the above mentioned specific authority shall be obtained on
              non-judicial stamp paper.
            </p>
          </div>

          <hr className="t-grey-200 "></hr>

          <div className="d-inline-flex w-100 mt-32">
            <h3 className="fs32 ls4 fw-800 t-grey-800">Terms & Conditions</h3>
          </div>

          <p className="fs16 t-pink-tc my-3 mt8">
            Please read and understand the Terms and Conditions, attached
            herewith as Annexure A, before signing and executing this form.
          </p>

          <div className="d-inline-flex w-100 mt28">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              DECLARATION & UNDERTAKING
            </h4>
          </div>

          <p className=" fs16 t-pink-tc my-3 mt8">
            I/We, the undersigned Applicant(s), hereby declare/undertake that:{" "}
            <br />
            <ol type="a">
              <li className="mt8">
                {" "}
                I/We am/are not minor(s); <br />
              </li>
              <li>
                {" "}
                I/We am/are of sound mind; <br />
              </li>
              <li>
                {" "}
                I/We have not applied to be adjudicated as an insolvent and that
                I/We have not suspended payment to any financial institution and
                that I/We have not compounded with my/our creditors; <br />
              </li>
              <li>
                {" "}
                I/We am/are not an undischarged insolvent; <br />
              </li>
              <li>
                {" "}
                I/We confirm and acknowledge that I/We have received the Terms
                and Conditions, duly stamped, dated, and signed by the
                Compliance Officer of Securities Broker/Participant, as an
                annexure to this Form at the time of signing of this Form and
                have carefully read, understood and accepted the attached Terms
                and Conditions which are deemed to be a part of this Form and
                I/We hereby unconditionally and irrevocably agree and undertake
                to be bound by and to comply with the attached Terms and
                Conditions and any other Terms and Conditions provided to me/us
                and placed on the website of the Securities Broker/Participant,
                which may be notified from time to time with the approval of the
                concerned authorities modifying or substituting all or any of
                the attached Terms and Conditions in connection with the
                opening, maintenance and operation of the Sub-Account / Trading
                Account, as the case may be; <br />
              </li>
              <li>
                {" "}
                I/ We hereby confirm that the Terms and Conditions shall
                constitute a Contract between the Parties hereto and govern
                opening, maintenance and operations of Trading Account,
                Sub-Account which shall be binding on the Sub-Account Holder as
                well as the Securities Broker/Participant and sharing of UIN and
                KYC information to/from NCCPL and ancillary matters connected
                therewith; <br />
              </li>
              <li>
                {" "}
                The information furnished in this form is complete, valid, true
                and correct to the best of my/our knowledge and I/We shall
                inform the Securities Broker/Participant immediately in writing
                of any change therein; <br />
              </li>
              <li>
                {" "}
                In case any of the above information is found to be false or
                misleading or suspension of any material fact, will render
                my/our Sub-Account/Trading Account, as the case may be, liable
                for termination and I/We shall be subject to further action
                under the law; <br />
              </li>
              <li>
                {" "}
                All the documents filed/submitted by me/us for the purpose of
                this application are genuine and valid, bearing genuine
                signatures and stamps of duly authorized
                individuals/representatives and are in accordance with the
                applicable law; <br />
              </li>
              <li>
                {" "}
                I/ We agree that I/we shall not place any trading order in case
                of any concern or disagreement with any Terms and Conditions
                shared by Securities Broker/Participant and placement of trading
                order shall mean that I/we have affirmed/consented with the
                Terms and Conditions; and <br />
              </li>
              <li>
                {" "}
                I/We hereby now apply for opening, maintaining and operating
                Sub-Account/Trading Account, as the case may be, with the
                Securities Broker/Participant. <br />
              </li>
              <div className=" my-3">
                {" "}
                I, the undersigned as Securities Broker/Participant, hereby
                declare/undertake/confirm that: <br />
              </div>
              <li>
                {" "}
                I have provided in full the Terms and Conditions attached as an
                Annexure to this Form to the Customer/Sub-Account Holder at the
                time of filing of this Form and I hereby further confirm that
                provided Terms and Conditions are available on our website and
                update the same immediately upon occurrence of any change in
                Terms and Conditions. I further confirm that trading
                account/Sub-Account of customer/Sub-Account Holder shall be
                activated/opened only upon affirmation of the Terms and
                Conditions by the customer/Sub-Account Holder; and <br />
              </li>
              <li>
                {" "}
                I have no doubt or concern that the Terms and Conditions shared
                with Customer/Sub-Account Holder by us are not updated and has
                any difference when compared with the specified Terms and
                Conditions and the attached Terms and Conditions also form part
                of this Form. <br />
              </li>
            </ol>
          </p>

          <div className="d-inline-flex w-100 mt28">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              DISCLAIMER FOR CDC ACCESS SERVICES
            </h4>
          </div>

          <p className="fs16 t-pink-tc my-3">
            The main objective of providing information, reports and account
            maintenance services through the Interactive Voice Response System,
            Internet /Web access and Short Messaging Service (“SMS”) or any
            other value added service is to facilitate the /Sub-Account Holders
            (“Users”) with a more modern way to access their information. CDC
            makes no other warranty of the IVR, Internet /Web access, SMS or any
            other value added services and Users hereby unconditionally agree
            that they shall make use of the internet/web access subject to all
            hazards and circumstances as exist with the use of the internet. CDC
            shall not be liable to any Users for providing and making available
            such services and for failure or delay in the provision of SMS to
            Users and all Users, who use the IVR, internet access, SMS or any
            other value added services, shall be deemed to have indemnified CDC,
            its directors, officers and employees for the time being in office
            and held them harmless from and against any losses, damages, costs
            and expenses incurred or suffered by them as a consequence of use of
            the IVR system, internet/web access, SMS or any other value added
            services.
          </p>
          <p className="fs16 t-pink-tc mt">
            All Users hereby warrant and agree that their access of the internet
            /web by the use of a User-ID and login is an advanced electronic
            signature and upon issuance of such User-ID to the user, they hereby
            waive any right to raise any objection to the compliance of the
            User-ID and login with the criteria of an advance electronic
            signature.
          </p>
          <p className="fs16 t-pink-tc mt mb">
            All Users shall by signing this Form and by their conduct of
            accessing the IVR, internet/Web access, SMS or any other value added
            services agree to all the terms and conditions and terms of use as
            shall appear on the CDC website at www.cdcaccess.com.pk which shall
            be deemed to have been read and agreed to by the Users before
            signing this form.
          </p>

          <span className="annexure">Annexure-A</span>

          <div className="d-inline-flex w-100 mt8">
            <h3 className="fs32 ls4 fw-800 t-grey-800">TERMS AND CONDITIONS</h3>
          </div>

          <p className="fs16 t-pink-tc mt28">
            Please read and understand the Terms and Conditions before signing
            and executing this form.
          </p>
          <p className="fs16 t-pink-tc mt16">
            These Terms and Conditions shall constitute a Contract between the
            Parties hereto. This Contract shall govern opening, maintenance and
            operations of Trading Account, CDC Sub-Account(s) and sharing of UIN
            and KYC information to/from NCCPL and ancillary matters connected
            therewith.
          </p>

          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              {" "}
              GENERAL TERMS AND CONDITIONS{" "}
            </h4>
          </div>
          <p className="fs16 t-pink-tc my-3 mt16">
            <ol>
              <li>
                {" "}
                All Trades, Transactions, including non-Exchange Transactions,
                Derivative Contracts and deals (jointly referred to as
                “Transactions”) between the Parties and Clearing and Settlement
                thereof and opening, maintenance and operations of Sub-Account
                in the CDS shall be subject to the Securities Act, 2015, Central
                Depositories Act, 1997, Pakistan Stock Exchange Limited (PSX)
                Regulations, Central Depository Company of Pakistan Limited
                (CDC) Regulations, CKO Regulations, 2017, National Clearing
                Company of Pakistan Limited (NCCPL) Regulations and the
                Securities Brokers (Licensing and Operations) Regulation, 2016
                including Procedures, Manuals, Polices, Guidelines, Circulars,
                Directives, and Notifications issued and as amended) thereunder
                by the Securities and Exchange Commission of Pakistan (SECP),
                PSX, CDC or NCCPL from time to time. <br />
              </li>
              <li>
                {" "}
                The information provided in KYC application form and/or CRF
                shall be in addition to and not in derogation of the
                requirements prescribed under Anti-Money Laundering and
                Countering Financing of Terrorism Regulations, 2020. <br />
              </li>
              <li>
                {" "}
                The Securities Broker/Participant shall ensure provision of
                copies of all the relevant laws, rules and regulations at its
                office for access to the Sub-Account Holder(s)/Customer(s)
                during working hours. The Securities Broker/Participant shall
                ensure that its website contains hyperlinks to the
                websites/pages on the website of PSX, CDC, NCCPL and the SECP
                displaying the above said regulatory framework for reference of
                the Customers. <br />
              </li>
              <li>
                {" "}
                In case of a Joint Account, all obligations and liabilities of
                the Applicants under these Terms and Conditions shall be joint
                and several. <br />
              </li>
              <li>
                {" "}
                These Terms and Conditions shall be binding on the nominee,
                legal representative, successors in interest and/or permitted
                assigns of the respective Parties hereto. <br />
              </li>
              <li>
                {" "}
                The Securities Broker/Participant shall provide a list of its
                Registered Offices and Representatives authorized and employees
                designated to deal with the SubAccount Holder(s)/Customer(s)
                along with their authorized mobile/landline/fax number(s), email
                and registered addresses. Any change(s) therein shall be
                intimated in writing to the Sub-Account Holder(s)/Customer(s)
                with immediate effect. <br />
              </li>
              <li>
                {" "}
                Subject to applicable laws, the Securities Broker/Participant
                shall maintain strict confidentiality of the Customer related
                information and shall not disclose the same to any third party.
                However, in case the SECP, PSX, CDC or any competent authority
                under the law, as the case may be, requires any such
                information, the Securities Broker/ Participant shall be obliged
                to disclose the same for which the Customer shall not raise any
                objection whatsoever. <br />
              </li>
              <li>
                {" "}
                The Securities Broker/Participant shall independently verify any
                of the Customer’s related information provided in this Form and
                under the relevant laws, rules and regulations for the purpose
                of KYC. <br />
              </li>
              <li>
                {" "}
                In case of any change in the Customer’s related information
                provided in this Form, the Customer shall provide necessary
                details to the Participant/Securities Broker. Upon receipt of
                instruction from the Customer, the Participant/Securities Broker
                shall give effect to such changes in the manner prescribed under
                the relevant regulations. The Participant/Securities Broker
                shall have the right to incorporate any change(s) in the
                Sub-Account Holder(s)/Customer’s information in the CDS as sent
                by NCCPL as CKO and that such change(s) shall be deemed to have
                been authorized by the Sub-Account Holder(s)/Customer(s). In
                case of any change in the Participant’s/Securities Broker’s
                address or contact numbers or any other related information, the
                Securities Broker/Participant shall immediately notify the
                Sub-Account Holder(s)/Customer(s). <br />
              </li>
              <li>
                {" "}
                Any change in this Form or these Terms and Conditions by virtue
                of any changes in the aforesaid legal frameworks shall be deemed
                to have been incorporated and modified the rights and duties of
                the Parties hereto. Such change(s) shall be immediately
                communicated by the Securities Broker/Participant to the
                SubAccount Holder(s)/Customer(s). <br />
              </li>
              <li>
                {" "}
                The Securities Broker/Participant and the Customer shall be
                entitled to terminate this Contract without giving any reasons
                to each other after giving notice in writing of not less than
                one month to the other Party. Notwithstanding any such
                termination, all rights, liabilities and obligations of the
                Parties arising out of or in respect of Transactions entered
                into prior to the termination of this Contract shall continue to
                subsist and vest in /be binding on the respective Parties or his
                /her/ its respective heirs, executors, administrators, legal
                representatives or successors in interest and permissible
                assigns, as the case may be. Closure of SubAccount of the
                Customer under this clause shall be subject to the condition
                that neither any corporate action is pending at that point of
                time in connection with any Book-entry Securities in the
                Sub-Account nor any Book-Entry Securities are in Pledged
                Position and that the outstanding dues, if any, payable by any
                Party to the other Party is cleared and that the Customer has
                transferred or withdrawn all the Book-Entry Securities from
                his/her Sub-Account. <br />
              </li>
              <li>
                {" "}
                Where applicable, the terms “Sub-Account Holder” and
                “Participant” used in this Form shall include the “Customer” and
                “Securities Broker/TRE Certificate Holder” respectively. <br />
              </li>
              <li>
                {" "}
                The Securities Broker/Participant should ensure due protection
                to the Sub-Account Holder / Customer regarding rights to
                dividend, rights or bonus shares etc. in respect of transactions
                routed through it and not do anything which is likely to harm
                the interest of the Sub-Account Holder with/from whom it may
                have had transactions in securities. <br />
              </li>
              <li>
                {" "}
                The Participant/Securities Broker shall ensure that duly filled
                in and signed copy of this form along with the acknowledgement
                receipt is provided to the SubAccount Holder. <br />
              </li>
            </ol>
          </p>

          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              {" "}
              TERMS AND CONDITIONS FOR OPENING AND OPERATIONS OF CDC SUB-ACCOUNT
            </h4>
          </div>

          <p className="fs16 t-pink-tc my-3">
            The Terms and Conditions set herein below shall govern the
            Sub-Account forming part of the Account Family of the CDS
            Participant Account of the Participant, which shall be binding on
            the Sub-Account Holder as well as the Participant:
          </p>
          <p className="fs16 t-pink-tc mt16">
            <ol>
              <li>
                {" "}
                The Registration Details and such other information specified by
                the Applicant in this form for opening of the Sub-Account shall
                appear in the Sub-Account to be established by the Participant
                in the CDS who shall ensure the correctness and completeness of
                the same. <br />
              </li>
              <li>
                {" "}
                The Book-entry Securities owned by the Sub-Account Holder shall
                be exclusively entered in the Sub-Account of such Sub-Account
                Holder. <br />
              </li>
              <li>
                {" "}
                Transfer, Pledge and Withdrawal of Book-entry Securities entered
                in the Sub-Account of the Sub-Account Holder shall only be made
                from time to time in accordance with the authorization given by
                the Sub-Account Holder to the Participant in Part (E) above
                pursuant to Section 12 and 24 of the Central Depositories Act,
                1997. Such authorization shall constitute the congregated /
                entire authorizations by the Sub-Account Holder(s) in favor of
                the Participant and supersedes and cancels all prior
                authorizations (oral, written or electronic) including any
                different, conflicting or additional terms which appear on any
                agreement or form the Sub-Account Holder(s) has executed in
                favor of the Participant. <br />
              </li>
              <li>
                {" "}
                Participant shall be liable to give due and timely effect to the
                instructions of the Sub-Account Holder given in terms of the
                above-referred authorization with respect to transfer, pledge
                and withdrawal of Book-entry Securities entered in his/her
                Sub-Account under the control of the Participant. Such
                instructions, among other matters, may include closing of
                Sub-Account. <br />
              </li>
              <li>
                {" "}
                Participant shall send within 10 days of end of each quarter
                Account Balance statement to the Sub-Account Holder without any
                fee or charge showing the number of every Book-entry Security
                entered in his/her Sub-Account as of the end of the preceding
                quarter. Such Account Balance statement shall be generated from
                the CDS. Further, the Sub-Account Holder may request for such
                statement (including Account Activity reports) from the
                Participant at any time on payment of a fee on cost basis as
                prescribed by the Participant. The Participant shall be liable
                to provide such report/statement to the Sub-Account Holder
                within 3 Business Days from the date of receipt of such request,
                with or without charges. <br />
              </li>
              <li>
                {" "}
                In consideration for the facilities and services provided to the
                Sub-Account Holder by the Participant, the Sub-Account Holder
                shall pay fees and charges to the Participant as applicable for
                availing such facilities and services under the Central
                Depositories Act, 1997, the Regulations and these Terms &
                Conditions. In case of outstanding payment against any
                underlying market purchase transaction, charges and/or losses
                against the Sub-Account Holder, the Participant shall have the
                right, subject to Clause 3 above and under prior intimation to
                the Sub-Account Holder to clear the payment, charges and/or
                losses (including any shortfall in margin requirements) within
                the reasonable time prescribed by the Participant, to dispose
                off the necessary number of Book-entry Securities of the
                Sub-Account Holder through market-based or Negotiated Deal
                Market sell transaction and apply the net proceeds thereof
                towards the adjustment of such outstanding payment, charges
                and/or losses. <br />
              </li>
              <li>
                {" "}
                Where admission of Participant to the CDS is suspended or
                terminated by the CDC, the Sub-Account Holder shall have the
                right, subject to the Regulations and the Procedures made
                thereunder, to request CDC to change his/her Controlling Account
                Holder and Participant shall extend full cooperation to the
                Sub-Account Holder in every regard, without prejudice to its
                right of recovery of any dues or receivable from the Sub-Account
                Holder. <br />
              </li>
              <li>
                {" "}
                The provision of services as provided for hereunder shall not
                constitute Participant as trustee and the Participant shall have
                no trust or other obligation in respect of the Book-entry
                Securities except as agreed by the Participant separately in
                writing. <br />
              </li>
              <li>
                {" "}
                The Participant is not acting under this application form as
                Investment Manager or Investment Advisor to the Sub-Account
                Holder(s). <br />
              </li>
            </ol>
          </p>

          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              {" "}
              TERMS AND CONDITIONS FOR TRADING ACCOUNT
            </h4>
          </div>

          <p className="fs16 t-pink-tc my-3">
            <ol>
              <li>
                {" "}
                In case any dispute in connection with the Transaction between
                the Securities Broker and the Customer is not settled amicably,
                either Party may refer the same to the Arbitration in accordance
                with the arbitration procedures prescribed in PSX Regulations.
                The decision of arbitrators shall be binding on both the Parties
                subject to their rights of appeal in the manner provided in PSX
                Regulations, if exercised. The name and other relevant
                particulars of the Customer shall be placed on PSX’s website
                accessible to Securities Brokers if the Customer fails or
                refuses to abide by or carryout any arbitration award passed
                against him/her and the Customer shall have no objection to the
                same. <br />
              </li>
              <li>
                {" "}
                The assets deposited as margin by a Customer with the Securities
                Broker shall only be used by the Securities Broker for the
                purposes of dealing in securities through PSX on behalf of such
                Customer other than as authorized by the Customer in writing in
                the manner prescribed under the relevant regulations. <br />
              </li>
              <li>
                {" "}
                The Securities Broker may deposit unutilized funds of the
                Customers in a separate profit-bearing bank account and shall
                distribute profit to the Customers out of total profit offered
                by bank(s) on such funds, unless specified otherwise in writing
                by the Customer. <br />
              </li>
              <li>
                {" "}
                The Securities Broker shall be authorized to act on the
                instructions of the Customers given through any of the following
                modes of communication unless specifically designated by the
                Customer in the Form: <br />
              </li>
              <ol type="a" className="mt8">
                <li>
                  {" "}
                  Telephonic communication over a dedicated telephone line(s)
                  routed through centralized call recording system; <br />
                </li>
                <li>
                  {" "}
                  Email/SMS/Fax/Letter on the authorized email
                  address/mobile/fax/address of the Securities Brokers; <br />
                </li>
                <li>
                  {" "}
                  Verbal orders placed through personal appearance in the
                  registered office subject to receipt of written
                  acknowledgement of such in-person orders by Securities
                  Brokers. <br />
                </li>
              </ol>
              <li className="mt8">
                {" "}
                The Securities Broker shall make out the Contract Note (physical
                or electronic form) to the Customers in respect of trades
                executed on their behalf based on their order instructions not
                later than the start of next trading day as required under the
                Securities Brokers (Licensing and Operations) Regulations, 2016
                through any of the following acceptable modes of communication
                unless specifically designated by the Customer in the Form:{" "}
                <br />
              </li>
              <ol type="a" className="mt8">
                <li>
                  {" "}
                  Recognized courier service; <br />
                </li>
                <li>
                  {" "}
                  Registered Post at given correspondence address; <br />
                </li>
                <li>
                  {" "}
                  Facsimile number provided on the Form; <br />
                </li>
                <li>
                  {" "}
                  By hand subject to receipt/acknowledgement; or <br />
                </li>

                <li>
                  {" "}
                  Email provided on the Form in case of Electronic Contract
                  Note. <br />
                </li>
              </ol>
              All such transactions recorded by the Securities Broker in the
              prescribed manner shall be conclusive and binding upon the
              Customer unless the Customer raises observation relating to
              unauthorized execution of such transaction or any error in the
              Contract Note within one trading day of the receipt of such
              Contract Note. In the event of any dispute relating to order
              placement or executing of orders, the burden of proof shall be on
              the Securities Brokers to establish the authenticity of such order
              placement or execution thereof. In case the Customer fails to
              deposit additional margins within one trading day of the margin
              call (in writing), the Securities Broker shall have absolute
              discretion to liquidate the Customer’s outstanding positions
              including the securities purchased and carried in such account to
              meet the margin shortfall without further notice to the Customer.{" "}
              <br />
              <li>
                {" "}
                The Securities Broker shall be responsible for the payment of
                any credit cash balance available in the account of the Customer
                through cross cheques or other banking channels (instruments)
                only within one (1) trading day of the request of the Customer
                subject to the maintenance of the margin requirements.
                <br />
              </li>
              <li>
                {" "}
                The Customer is aware that in the event of his/her non- payment
                on settlement day against securities bought on his/her account,
                the Securities Broker may transfer such securities to its
                Collateral Account under intimation to PSX in the manner as
                provided in PSX Regulations. <br />
              </li>
              <li>
                {" "}
                The Securities Broker shall accept from the Customer payments
                through "A/c Payee Only" crossed cheque, bank drafts, pay orders
                or other banking channels drawn on Customer’s own bank account
                in case of amounts in excess of Rs. 25,000/-. Electronic
                transfer of funds to the Securities Broker through banks would
                be regarded as good as cheque. The Securities Broker shall
                provide the receipt to the Customer(s) in the name of the
                Customers duly signed by its authorized employee and the
                Customer(s) shall be responsible to obtain the receipt thereof.
                In case of cash dealings, proper receipt will be taken and given
                to the Customer(s), specifically mentioning if payment is for
                margin or the purchase of securities. The Securities Broker
                shall immediately deposit in its bank account all cash received
                in whole i.e. no payments shall be made from the cash received
                from clients. However, in exceptional circumstances, where it
                becomes necessary for Securities Broker to accept cash in excess
                of Rs.25,000/-, the Securities Broker shall immediately report
                within one trading day such instances with rationale thereof to
                the PSX in accordance with the mechanism prescribed by PSX.
                <br />
              </li>
              <li>
                {" "}
                The Securities Brokers shall make all payments to the Customers
                through crossed cheques / bank drafts / pay orders or any other
                banking channels showing payment of amount from their business
                bank account. Copies of these payment instruments including
                cheques, pay orders, demand drafts and online instructions shall
                be kept in record for a minimum period prescribed under the
                Securities Brokers (Licensing and Operations) Regulations, 2016.{" "}
                <br />
              </li>
              <li>
                {" "}
                The Securities Broker shall provide to the Customers a quarterly
                Account Statement which shall include cash and securities
                ledgers as back office and CDC SubAccount records along with
                reconciliation of any differences therein through any of the
                aforesaid modes of communication. In case of any discrepancy in
                the ledger statement, the Customer shall inform the Securities
                Broker within seven (7) days of receipt of the quarterly account
                statement to remove such discrepancy. Further, the Securities
                Broker shall provide to a Customer an Account Statement for a
                period specified by the Customer as and when requested by such
                Customer. <br />
              </li>
              <li>
                {" "}
                The Customer shall pay all applicable taxes and statutory and
                regulatory fee and levies and brokerage commissions as are
                prevailing from time to time in connection with the brokerage
                services rendered. The Securities Broker/Participant can debit
                up to the accrued amount of levies and charges the account of
                the Customers for the abovementioned charges, which shall be
                clearly detailed in the ledger statement/daily confirmations.
                Any change resulting in an increase in the brokerage commission
                shall take effect not earlier than five (5) trading days of
                intimation of the same to the Customers through acceptable mode
                of communication prescribed in the Form. <br />
              </li>
              <li>
                {" "}
                The Securities Broker shall append a Risk Disclosure Document
                with this Form in accordance with the specimen provided by PSX.
                <br />
              </li>
            </ol>
          </p>

          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              Margin Financing (MF)/ Margin Trading (MT)/ Security Lending and
              Borrowing (SLB):
            </h4>
          </div>

          <p className="fs16 t-pink-tc my-3">
            For Margin Financing/Margin Trading/ Securities Lending & Borrowing,
            the following Additional Terms and Conditions shall apply:
          </p>

          <p className="fs16 t-pink-tc my-3">
            <ol type="a" className="mt8">
              <li>
                Margin Financing, Margin Trading, Securities Lending and
                Borrowing and Pledging of Securities on account of the Account
                Holder shall be governed by the Securities (Leveraged Markets
                and Pledging) Rules, 2011 and any amendments thereto or
                substitutions thereof or any other legal or regulatory
                requirement as implemented from time to time. The Account
                Holder(s) undertake(s) to execute the Broker's standardized
                documents for such transactions, including those prescribed by
                SECP, PSX, NCCPL, etc
                <br />
              </li>{" "}
              <br />
              <li>
                The Account Holder(s) shall be eligible to enter into multiple
                Margin Financing/Margin Trading/SLB Contracts at the same time
                and shall be for a tenure not greater than the respective tenure
                prescribed by the PSX from time to time or such other period as
                the Broker may at its sole discretion determine. <br />
              </li>{" "}
              <br />
              <li>
                The minimum equity participation amount that the Broker shall
                accept for each MF/MT/SLB Contract shall not be lower than the
                limit prescribed by the National Clearing Company of Pakistan
                Limited Regulations, 2003, (Regulations) as amended and/or
                modified from time to time. However, the Broker at its
                discretion can request for higher equity participation than what
                is prescribed in the Regulations. <br />
              </li>
              <br />
              <li>
                In respect of MT/MF/SLB transactions, the Account Holder(s)
                shall pay to the Broker mark-up on financing computed at the
                rate as decided from time to time pro-rated to the actual number
                of days for which any amount is financed to or on account of the
                Account Holder(s). The Broker shall have the right to debit
                Account Holder(s) account for the mark-up and the Account
                Holder(s) undertake(s) to pay the mark-up immediately upon
                written demand from the Broker without raising any issues.
                <br />
              </li>
              <br />
              <li>
                The purchase of securities shall be carried out by the Account
                Holder(s) only in respect of MT/MF/SLB Eligible Securities as
                decided by the Broker from time to time. The Account Holder(s)
                accept(s) and acknowledge(s) that the Broker has the sole
                discretion to limit the number of MT/MF Eligible Securities for
                which it may wish to facilitate the Account Holder(s), and the
                Account Holder(s) can only ask for facilitation of those
                MT/MF/SLB Eligible Securities from the Broker which the Broker
                has short-listed. Any change to the MT/MF/SLB Eligible
                Securities shall be effected immediately by the Broker except
                where the MT/MF/SLB Securities’ contract already executed
                require otherwise. <br />
              </li>
              <br />
              <li>
                In case of any corporate action such as a dividend declaration
                or a rights announcement by a MT/MF/SLB Eligible Security which
                has been financed by the Broker / MT Financier, such right shall
                remain vested with the Account Holder(s) and the Broker/MT
                Financier shall not benefit from such actions inspite of the
                securities being in its custody. <br />
              </li>{" "}
              <br />
              <li>
                {" "}
                If there is any loss in the Account Holder(s)' account due to
                Mark-to-Market (MTM) of the MT/MF/SLB Contract, such losses
                shall be settled by the Account Holder(s) within one business
                day. <br />
              </li>
              <br />
              <li>
                {" "}
                The Broker is hereby authorized by the Account Holder(s) to
                mortgage, pledge or hypothecate the securities deposited or
                bought on behalf of the Account Holder(s) by the Broker to the
                related financial institution for a sum not exceeding the
                outstanding balance in the margin account, to the extent that
                the same is permissible under the applicable laws, Rules and
                Regulations.
                <br />
              </li>
              <br />
              <li>
                {" "}
                The Account Holder(s) unconditionally agree(s) that his/her/its/
                their securities may be sold by the margin financer, in case of
                any default or margin call not being addressed as per the
                requirements of Rules & Regulations as applicable from time to
                time, in the course of financing.
                <br />
              </li>
              <br />
              <li>
                Notwithstanding the conditions of Clauses 1 and 5 of the Terms
                and Conditions for trading account, in the event of default,
                failure, refusal or inability on part of the Account Holder(s)
                to repay the finance or any outstanding mark-up thereon, the
                Broker shall have the right to square up and liquidate the
                position of the Account Holder(s) and sell all the securities
                held on account of the Account Holder(s) upon one business days’
                notice to the Account Holder(s). The net sale proceeds so
                realized after deduction of brokerage, costs, taxes, duties,
                etc. shall be applied towards adjustment of the outstanding owed
                by the Account Holder(s) to the Broker. In case of any
                shortfall, the Account Holder(s) shall be liable to pay the same
                to the Broker with late payment charges at the rate mentioned in
                Clause V above, computed from the due date(s) of the outstanding
                amount up to the date of actual realization by the Broker.
                <br />
              </li>
              <br />
              <li>
                It is hereby distinctly understood that the grant of this MT/MF
                Facility by the Broker to the Account Holder(s) is subject to
                the provisions of the Securities (Leveraged Markets and
                Pledging) Rules, 2011 with such variations and modifications as
                may be made from time to time. The Account Holder(s) has/have
                read, understood and agreed to abide by the provisions of the
                said Rules, as well as other applicable Rules and Regulations.
                Further, all applicable Procedures, prescribed Documents,
                Policies, Notifications, Rules, Regulations, etc. issued or made
                by the Stock Exchange/ NCCPL/Commission in respect of Margin
                Financing/ Marin Trading shall become applicable and binding on
                the Account Holder(s) and the Broker. If any fine is imposed or
                other adverse action is taken by the Commission or the Stock
                Exchange or NCCPL against the Broker due to non-compliance of
                any of the provisions of the said Rules and/or any direction of
                the Commission or the Stock Exchange or NCCPL by the Account
                Holder(s), the Account Holder(s) shall be liable to pay the same
                to the Broker and indemnify and keep indemnified the Broker
                against all losses, costs, expenses, demands, proceedings and
                compensate the Broker in all respect to the full extent <br />
              </li>
              <br />
              <li>
                The Broker hereby discloses, and the Account Holder(s)
                acknowledge(s) that the transaction and activity of margin
                trading/margin financing has its inherent risks, and
                consequently, the Account Holder(s) by entering into this
                Agreement accepts such risks. Such risks include, but are not
                limited to, default risk, economic risk, market risk, regulatory
                risk, interest rate risk, priority rights of other creditors in
                case of liquidation, and other force majeure events like
                terrorism, acts of God, civil commotion, failure of
                communication and I.T. related systems downtime or other
                glitches, etc. <br />
              </li>
              <br />
              <li>
                The Account Holder(s) represent(s) that the funds being provided
                by him/her/them/it is/are his/her/its/their own funds and not
                obtained or borrowed from any other person. <br />
              </li>
              <br />
            </ol>
          </p>

          <div className="d-inline-flex w-100 mt8">
            <h3 className="fs32 ls4 fw-800 t-grey-800">
              TERMS AND CONDITIONS FORMING MANDATORY PART OF KYC APPLICATION
              FORM FOR INDIVIDUAL{" "}
            </h3>
          </div>

          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              {" "}
              Terms & Conditions of the KYC Application Form:
            </h4>
          </div>

          <p className="fs16 t-pink-tc my-3">
            <ol>
              <li>
                All terms herein shall, unless expressly stated otherwise, have
                the same meaning as ascribed to them in the Centralized KYC
                Organization Regulations.
              </li>{" "}
              <br />
              <li>
                The information provided in KYC application form and/or CRF
                shall be in addition to and not in derogation of the
                requirements prescribed under Anti-Money Laundering and
                Countering Financing of Terrorism Regulations, 2018.
              </li>
              <br />
              <li>
                All correspondence shall be sent by CKO at the mailing address
                and/or email address of the Customer, as stated on the KYC
                Application Form. KYC application form shall be submitted
                electronically for Online Account Opening of Individual
                Pakistani Customer by Authorized Intermediary that is a
                Securities Broker.
              </li>
              <br />
              <li>
                Neither the CKO nor its directors, officers, employees or agents
                shall be liable for losses, damages, liabilities, costs or
                expenses suffered or incurred by the Customer as a result of
                providing its KYC Information to Authorized Intermediaries or
                the CKO due to any reasons whatsoever including its unauthorized
                disclosure.
              </li>
              <br />
              <li>
                The Customer undertakes to indemnify the CKO against any losses,
                damages, liabilities, costs or expenses suffered or incurred by
                CKO, including any legal costs and claims by third parties, as a
                result of any inaccuracy, misrepresentation, misstatement or
                incorrect details in the information supplied by the Customer or
                any omission in such information or any other contravention or
                violation of the Centralized KYC Organization Regulations
              </li>
              <br />
              <li>
                The Customer agrees that in the event that he does not abide by
                the timelines prescribed in the Centralized KYC Organization
                Regulations for submission of information and confirmation to
                the NCCPL, the NCCPL shall be authorized to take action as
                prescribed in the Centralized KYC Organization Regulations. The
                Customer undertakes that it shall hold CKO harmless and that CKO
                shall not be liable for any losses, damages, liabilities, costs
                or expenses suffered or incurred by the Customer as a result of
                such actions.
              </li>
              <br />
              <li>
                The Customer agrees that CKO may hold, store and process its KYC
                Information on the KYC Information System and KYC Database in
                connection with its KYC functions under the Centralized KYC
                Organization Regulations. The Customer also agrees that CKO may
                disclose its KYC Information as permitted under the CKO
                Regulations and such other disclosures as may be reasonably
                necessary for compliance with any other laws or regulatory
                requirements.
              </li>
              <br />
              <li>
                The Customer acknowledges that KYC Information System and KYC
                Database, including but not limited to all the information
                contained therein is the legal property of CKO.
              </li>
              <br />
              <li>
                The Customer agrees that verification against KYC information
                provided by Customer and Authorized Intermediaries, shall be
                informed by CKO as per CKO Regulations and such verifications
                shall include verification of KYC information through linked
                services such as RAAST, 1-Link, PMD, NADRA, etc.
              </li>
              <br />
              <li>
                The Authorized Intermediaries agree to pay CKO the fees and
                charges as prescribed by CKO from time to time in respect of its
                KYC functions.
              </li>
              <br />
              <li>
                CKO has absolute discretion to amend or supplement any of the
                terms and conditions at any time and will endeavor to give prior
                notice of fifteen days wherever feasible for such changes.
              </li>
              <br />
              <li>
                The Customer agrees and affirms that it shall be bound by and
                acts in accordance with the provisions of the Centralized KYC
                Organization Regulations.
              </li>
              <br />
              <li>
                These terms and conditions shall be governed by the laws of
                Pakistan.
              </li>
              <br />
            </ol>
          </p>

          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              RISK DISCLOSURE DOCUMENT
            </h4>
          </div>
          <p className="fs16 t-pink-tc my-3">
            This Risk Disclosure document is prescribed by the Pakistan Stock
            Exchange Limited (PSX) under Clause 13(1) of the Securities Broker
            (Licensing and Operations) Regulations, 2016.
          </p>
          <p className="fs16 t-pink-tc my-3">
            This document contains important information relating to various
            types of risks associated with trading and investment in financial
            products (equity securities, fixed income instruments, derivatives
            contracts etc.) being traded at PSX. The customers should carefully
            read this document before opening a trading account with a broker.
          </p>
          <p className="fs16 t-pink-tc my-3">
            In case a customer suffers negative consequences or losses as a
            result of trading/investment, he/she shall be solely responsible for
            the same and PSX or Securities and Exchange Commission of Pakistan
            (SECP) shall not be held responsible/liable, in any manner
            whatsoever, for such negative consequences or losses.
          </p>
          <p className="fs16 t-pink-tc my-3">
            The customers must acknowledge and accept that there can be no
            guaranteed profit or guaranteed return on their invested capital and
            under no circumstances a broker can provide customers such guarantee
            or fixed return on their investment in view of the fact that the
            prices of securities and futures contract can fall as well as rise
            depending on the market conditions and performance of the companies.
            Customers must understand that past performance is not a guide to
            future performance of the securities, contracts or market as a
            whole. In case the customers have any doubt or are unclear as to the
            risks/information disclosed in this document, PSX strongly
            recommends that such customers should seek independent legal or
            financial advice in advance.
          </p>
          <p className="fs16 t-pink-tc my-3">
            PSX neither singly or jointly and expressly nor impliedly guarantee
            nor make any representation concerning the completeness, accuracy
            and adequacy of the information contained in this document as this
            document discloses the risks and other significant aspects of
            trading/investment at the minimum level. PSX does not provide or
            purport to provide any advice and shall not be liable to any person
            who enters into a business relationship with a broker based on any
            information contained in this document. Any information contained in
            this document must not be construed as business/investment advice in
            any manner whatsoever.
          </p>
          <div className="d-inline-flex w-100 mt">
            <h4 className="fs32 ls4 fw-800 t-grey-800">
              THE CUSTOMERS MUST BE AWARE OF AND ACQUAINTED WITH THE FOLLOWING
            </h4>
          </div>
          <div className="d-inline-flex w-100 mt16">
            <h5 className="fs32 ls4 fw-800 t-grey-800">
              1. BASIC RISKS INVOLVED IN TRADING IN SECURITIES MARKET:
            </h5>
          </div>

          <div className="ml40">
            <div className="d-inline-flex w-100 mt28">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.1 VOLATILITY RISK:
              </h5>
            </div>

            <p className="fs16 t-pink-tc my-3">
              Volatility risk is the risk of changes in the value of financial
              product in any direction. High volatility generally means that the
              values of securities/contracts can undergo dramatic upswings
              and/or downswings during a short period. Such a high volatility
              can be expected relatively more in illiquid or less frequently
              traded securities/contracts than in liquid or more frequently
              traded one, due to volatility, the order of a customer may not be
              executed or only partially executed due to rapid change in the
              market prices. Such volatility can also cause price uncertainty of
              the market orders as the price at which the order is executed can
              be substantially different from the lost available market price or
              may change significantly thereafter, resulting in a real or
              notional loss.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.2 LIQUIDITY RISK:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              Liquidity refers to the ability of market participants to buy
              and/or sell securities expeditiously at a competitive price and
              with minimal price difference. Generally, it is assumed that more
              the number of orders available in a market, greater is the
              liquidity. Liquidity is important because with greater liquidity,
              it is easier for customers to buy and/or sell securities swiftly
              and with minimal price difference and, as a result, customers are
              more likely to pay or receive a competitive price for their
              executed trades. Generally, lower liquidity can be expected in
              thinly traded instruments than in liquid or more frequently traded
              ones. As a result, order of customer may only be partially
              executed, or may be executed with relatively greater price
              difference or may not be executed at all. Under certain market
              conditions, it may be difficult or impossible for the customers to
              liquidate a position in the market at a reasonable price, when
              there are no outstanding orders either on the buy side or on the
              sell side, or if trading is halted in a security/contract due to
              any reason.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.3 SPECULATIVE TRADING RISK:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              Speculation involves trading of a security/contract with the
              expectation that it will become more valuable in a very near
              future. These transactions are attempted to make profit from
              fluctuations in the market value of securities, rather than
              fundamental value of a security and/or underlying attributes
              embodied in the securities such as dividends, bonus or any other
              factor(s) materially affecting the price
            </p>

            <p className="fs16 t-pink-tc my-3">
              Speculative trading results in an uncertain degree of gain or
              loss. Almost all investment activities involve speculative risks
              to some extent, as a customer has no idea whether an investment
              will be a blazing success or an utter failure.
            </p>
            <p className="fs16 t-pink-tc my-3">
              Day trading strategy is a common example of speculative trading in
              which customers buy and sell the same security/derivative within
              the same day, such that all obligations are netted off and closed
              and no settlement obligations stand. The customer indulging in a
              day-trading strategy needs to be more vigilant and informed than
              the customer investing for a longer period, as the market may not
              move during the day as the day-trader originally anticipated,
              resulting in a loss to them.
            </p>

            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.4 RISK OF WIDER SPREAD:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              The Bid-Ask spread is the difference between the offer price and
              bid price of a security/contract quoted by the Market Makers or
              trading parties. The size of spread is affected by a number of
              factors such as liquidity, volatility, free float (the total
              number of shares outstanding that are readily available for
              trading) etc. Generally, low liquidity, high volatility and low
              free float levels of a security may result in relatively wider
              Bid-Ask Spread. The higher Bid-Ask spread can result in greater
              cost to customers
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.5 RISK PERTAINING TO THE PRICE FLUCTUATIONS DUE TO CORPORATE
                ANNOUNCEMENT:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              The corporate announcements by the issuers for the corporate
              actions or any other material information may affect the price of
              the securities. These announcements combined with relatively lower
              liquidity of the security may result in significant price
              volatility. The customers, while making any investment decision in
              such securities/contracts, are advised to take into account such
              announcements. Moreover, the customers should be cautious and
              vigilant in case fake rumors are circulating in the market. The
              Customers are advised to refrain from acting purely based on such
              rumors rather take well informed investment decision in light of
              all facts and circumstances associated with such securities and
              their issuers.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.6 RISK REDUCING ORDERS:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              The customers can place orders for limiting the losses to certain
              amounts, such as Limit Orders, Stop Loss Orders, and Market Orders
              etc. Customers must ask their brokers for detailed understanding
              of these order types. Customers must acknowledge that placement of
              such orders for limiting losses to certain extent may not always
              be an effective tool due to rapid movements in the prices of
              securities and, as a result, such orders may not be executed.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">1.7 SYSTEM RISK:</h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              High volume trading will frequently occur at the market opening
              and before market close. Such high volumes may also occur at any
              point in the day causing delay in order execution or confirmation.
              During periods of volatility, on account of market participants
              continuously modifying their order quantity or prices or placing
              fresh orders, there may be delays in order execution and its
              confirmations.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">1.8 SYSTEMIC RISK:</h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              Systemic risk arises in exceptional circumstances and is the risk
              that the inability of one or more market participants to perform
              as expected will cause other participants to be unable to meet
              their obligations when due, thereby affecting the entire capital
              market.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.9 SYSTEM AND NETWORKING RISK:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              Trading on the PSX is done electronically, based on
              satellite/leased line-based communications, combination of
              technologies and computer systems to place and route orders. All
              these facilities and systems are vulnerable to temporary
              disruption or failure, or any such other problem/glitch, which may
              lead to failure to establish access to the trading system/network.
              Such limitation may result in delay in processing or processing of
              buy or sell orders in part only or non-processing of orders at
              all. As with any financial transaction, the customer may
              experience losses if orders cannot be executed normally due to
              systems failures on the part of exchange or broker. The losses may
              be greater if the broker having customers’ position does not have
              adequate back-up systems or procedures. Accordingly, the Customers
              are cautioned to note that although these problems may be
              temporary in nature, but when the customers have outstanding open
              positions or unexecuted orders, these limitations represent a risk
              because of obligations to settle all executed transactions.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.10 RISK OF ONLINE SERVICES:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              The customers who trade or intend to trade online should fully
              understand the potential risks associated with online trading.
              Online trading may not be completely secure and reliable and may
              cause delay in transmitting information, execution of instructions
              due to technological barriers. Moreover, the customer acknowledges
              and fully understands that he/she shall be solely responsible for
              any consequences arising from disclosure of the access codes
              and/or passwords to any third person or any unauthorized use of
              the access codes and/or passwords.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                1.11 REGULATORY/LEGAL RISK:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              Government policies, rules, regulations, and procedures governing
              trading on the exchange are updated from time to time. Such
              regulatory actions and changes in the legal/regulatory ecosystem
              including but not limited to changes in tax/levies may alter the
              potential profit of an investment. Some policies of the government
              may be focused more on some sectors than others thereby affecting
              the risk and return profile of the investment of the customers in
              those sectors.
            </p>
          </div>

          <div className="d-inline-flex w-100 mt">
            <h5 className="fs32 ls4 fw-800 t-grey-800">
              2. RISKS IN DERIVATIVE AND LEVERAGE PRODUCTS:
            </h5>
          </div>
          <p className="fs16 t-pink-tc my-3">
            Derivative and leveraged trades enable the customer to take larger
            exposure with smaller amount of investment as margin. Such trades
            carry high level of risk and the customers should carefully consider
            whether the trading in the derivative and leveraged products is
            suitable for them, as it may not be suitable for all customers. The
            higher the degree of leverage, the greater the possibility of profit
            or loss it can generate in comparison with the investment involving
            full amount. Therefore, the customers should trade in the derivative
            and leveraged products in light of their experiences, objectives,
            financial resources and other relevant circumstances.
          </p>
          <p className="fs16 t-pink-tc my-3">
            Derivative product namely Deliverable Futures Contract, Cash Settled
            Futures Contract, Stock Index Futures Contract and Index Options
            Contracts and leveraged products namely Margin Trading System,
            Margin Financing and Securities Lending and Borrowing are available
            for trading at stock exchange.
          </p>
          <p className="fs16 t-pink-tc my-3">
            The customer transacting in the derivative and leveraged markets
            needs to carefully review the agreement provided by the brokers and
            also thoroughly read and understand the specifications, terms and
            conditions which may include markup rate, risk disclosures etc.
            There are a number of additional risks that all customers need to
            consider while entering into derivative and leveraged market
            transactions. These risks include the following: <br />
            <div className="mt16">
              <ol type="a">
                <li>
                  {" "}
                  Trading in the derivative and leveraged markets involves risk
                  and may result in potentially unlimited losses that are
                  greater than the amount deposited with the broker. As with any
                  high-risk financial product, the customer should not risk any
                  funds that the customer cannot afford to lose, such as
                  retirement savings, medical and other emergency funds, funds
                  set aside for purposes such as education or home ownership,
                  proceeds from student loans or mortgages, or funds required to
                  meet living expenses.
                  <br />
                </li>
                <li>
                  {" "}
                  All derivative and leveraged trading involve risk, and there
                  is no trading strategy that can eliminate it. Strategies using
                  combinations of positions, such as spreads, may be as risky as
                  outright long or short positions. Trading in equity futures
                  contracts requires knowledge of both the securities and the
                  futures markets.
                  <br />
                </li>
                <li>
                  {" "}
                  The customer needs to be cautious of claims of large profits
                  from trading in such products. Although the high degree of
                  leverage can result in large and immediate gains, it can also
                  result in large and immediate losses.
                  <br />
                </li>
                <li>
                  {" "}
                  Because of the leverage involved and the nature of equity
                  futures contract transactions, customer may feel the effects
                  of his/her losses immediately. The amount of initial margin is
                  small relative to the value of the futures contract so that
                  transactions are ’leveraged’ or 'geared’. A relatively small
                  market movement will have a proportionately larger impact on
                  the funds the customer has deposited or will have to deposit.
                  This may work against customer as well as for him/her.
                  Customer may sustain a total loss of initial margin funds and
                  any additional funds deposited with the broker to maintain
                  his/her position. If the market moves against his/her position
                  or margin levels are increased, customer may be called upon to
                  pay substantial additional funds on short notice to maintain
                  his/her position. If the customer fails to comply with a
                  request/call for additional funds within the time specified,
                  his/her position may be liquidated/squared-up at a loss, and
                  customer will be liable for the loss, if any, in his/her
                  account.
                  <br />
                </li>
                <li>
                  {" "}
                  The customer may find it difficult or impossible to
                  liquidate/square-up a position due to certain market
                  conditions. Generally, the customer enters into an offsetting
                  transaction in order to liquidate/square-up a position in a
                  derivative or leverage contract or to limit the risk. If the
                  customers cannot liquidate position, they may not be able to
                  realize a gain in the value on position or prevent losses from
                  increasing. This inability to liquidate could occur, for
                  example, if trading is halted due to some emergency or unusual
                  event in either the equity futures contract or the underlying
                  security, no trading due to imposition of circuit breaker or
                  system failure occurs on the part of exchange or at the broker
                  carrying customers' position. Even if customers can liquidate
                  position, they may be forced to do so at a price that involves
                  a large loss. <br />
                </li>
                <li>
                  {" "}
                  Under certain market conditions, the prices of derivative
                  contracts may not maintain their customary or anticipated
                  relationships to the prices of the underlying security. These
                  pricing disparities could occur, for example, when the market
                  for the equity futures contract is illiquid, when the primary
                  market for the underlying security is closed, or when the
                  reporting of transactions in the underlying security has been
                  delayed.
                  <br />
                </li>
                <li>
                  {" "}
                  The customer may be required to settle certain futures
                  contracts with physical delivery of the underlying security.
                  If the customer hold position in a physically settled equity
                  futures contract until the end of the last trading day prior
                  to expiration, the customer shall be obligated to make or take
                  delivery of the underlying securities, which could involve
                  additional costs. The customer should carefully review the
                  settlement and delivery conditions before entering into an
                  equity futures contract.
                  <br />
                </li>
                <li>
                  {" "}
                  Day trading strategies involving equity futures contracts and
                  other products pose special risks. As with any financial
                  product, customers who seek to purchase and sell the same
                  equity futures in the course of a day to profit from intra-day
                  price movements ("day traders") face a number of special
                  risks, including substantial commissions, exposure to
                  leverage, and competition with professional traders.
                  <br />
                </li>
                <li>
                  {" "}
                  The customer should thoroughly understand these risks and have
                  appropriate experience before engaging in day trading. The
                  customer should obtain a clear explanation of all commission,
                  fees and other charges for which he/she will be liable. These
                  charges will affect net profit (if any) or increase loss.
                  <br />
                </li>
              </ol>
            </div>
          </p>

          <div className="d-inline-flex w-100">
            <h5 className="fs32 ls4 fw-800 t-grey-800">3. GENERAL:</h5>
          </div>

          <div className="ml40">
            <div className="d-inline-flex w-100 mt28">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                3.1 ASSETS HELD WITH BROKERS:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              The customer should familiarize him/herself with the measures
              available for protecting from the risk of misappropriation or
              misuse of cash and securities held with the brokers. For such
              purpose, he/she may opt for UIN Information System (UIS) provided
              by National Clearing Company of Pakistan Limited (NCCPL). The
              customer should also provide correct mobile number/email address
              in order to receive SMS/e-Alerts services being provided by the
              NCCPL and Central Depository Company of Pakistan Limited (CDC) on
              each trade and movement of their securities.
            </p>
            <p className="fs16 t-pink-tc my-3">
              Moreover, the customers should be aware of the protections given
              to money and securities deposited with the brokers, particularly
              in the event of a default by such broker or the broker's
              insolvency or bankruptcy. The customer recognizes that in such
              default/insolvency/bankruptcy scenario, the customer may recover
              his/her money and/or property to such extent as may be governed by
              relevant PSX Regulations and/or local laws in force from time to
              time.
            </p>
            <div className="d-inline-flex w-100">
              <h5 className="fs32 ls4 fw-800 t-grey-800">
                3.2 CUSTOMERS RIGHTS AND OBLIGATIONS:
              </h5>
            </div>
            <p className="fs16 t-pink-tc my-3">
              The customer must understand their rights and obligations as well
              as the rights and obligations of the brokers specified under the
              PSX Regulations and the Standardized Account Opening Form, Know
              Your Client Form, Standardized Sub-Account Opening Form of CDC,
              and Agreement(s) of Leveraged Products (Margin Trading System,
              Margin Financing and Securities Lending and Borrowing), where
              applicable, and any other applicable Rules, Regulations,
              Guidelines, Circulars etc. as may be issued by SECP and PSX from
              time to time.
            </p>
            <p className="fs16 t-pink-tc my-3">
              <ol type="a">
                <li>
                  {" "}
                  The customers should ensure that they deal through the
                  registered branch and with the registered
                  Agents/Traders/Representatives of the broker. The customer
                  shall also verify such details from the website of PSX and Jam
                  punji (www.jamapunji.pk);
                  <br />
                </li>
                <li>
                  {" "}
                  Customer at the time of establishing relationship with the
                  brokers, should obtain a clear explanation of all brokerage,
                  commission, fees and other charges for which customer will be
                  liable to pay and these charges will affect net cash inflow or
                  outflow;
                  <br />
                </li>
                <li>
                  {" "}
                  It is obligatory for the brokers to issue contract note, in
                  either electronic form or hard copy, by next working day of
                  trading. The contract note shall contain all information
                  relating to trade execution including commission and charges
                  applicable on the customers. In case contract note is not
                  issued, customer should inquire with broker immediately and in
                  case the matter is not resolved, the same should be reported
                  to the PSX;
                  <br />
                </li>
                <li>
                  {" "}
                  The customers should match the information as per the contract
                  notes with the SMS/e-Alert received from CDC and/or NCCPL and
                  may also verify from the UIS facility from the website of
                  NCCPL.
                  <br />
                </li>
              </ol>
            </p>
          </div>
          <div className="d-inline-flex w-100">
            <h4 className="fs32 ls4 fw-800 t-grey-800">UNDERTAKING</h4>
          </div>

          <p className="fs16 t-pink-tc my-3 ">
            I, the customer, hereby acknowledge that I have received this Risk
            Disclosure Document and have read and understood the nature of all
            risks and other contents and information provided in this document.
          </p>

          <div className="d-inline-flex w-100 mt">
            <h3 className="fs32 ls4 fw-800 t-grey-800">
              SPECIAL TERMS AND CONDITIONS FOR ONLINE TRADING:
            </h3>
          </div>

          <p className="fs16 t-pink-tc my-3">
            Online trading will be permitted through Next Capital Limited
            (Broker) which will act as the Broker for the purpose of buying and
            selling Securities, including trading through Margin Financing
            System (MFS) and/or other forms of leveraging/margin financing at
            the Pakistan Stock Exchange (Online Exchange) and wherever the term
            Next CAPITAL LIMITED is used in these Special terms and Conditions
            for Online Trading, it shall deem to mean the Broker and Vice Versa.
          </p>
          <p className="fs16 t-pink-tc my-3">
            A Password or Personal Identification Number (PIN) will be issued to
            the Account Holder(s) by the broker as the Account Holder(s)
            password/PIN to enable the Account Holder(s) to have access to and
            use the Account for Online Trading. The Password/PIN may be
            communicated through E-mail or through courier to the Account
            Holder(s) at his/her/their own risk. The Account Holder(s) shall not
            disclose the Password/PIN to any person and shall take every
            reasonable precaution to prevent discovery of the Password/PIN by
            any other person(s).
          </p>
          <p className="fs16 t-pink-tc my-3">
            The Account Holder(s) shall ensure that all information needed by
            the Broker to verify the identity of Account Holders is accurately
            disclosed to the Broker over the telephone. It is further clarified
            that any/all instructions by the Account Holder(s) to the Broker via
            telephone shall be communicated (imparted) only through the Broker’s
            designated telephone number(s) which shall be notified to the
            Account Holder(s). Any change in such telephone numbers shall be
            promptly notified to the Account Holder(s). Any
            instruction/communication exchange through telephone numbers other
            than those which have been notified by the Broker shall not be
            entertained.
          </p>
          <p className="fs16 t-pink-tc my-3">
            All orders received telephonically and placed on KATS shall be
            supported by recording on dedicated telephonic lines, preferably
            connected with a computerized taping system so as the orders could
            possibly be stored on UIN basis and made user friendly. The account
            holder should give all orders through his registered phone number
            given in account opening form. The broker reserves the right not to
            accept any order given by other phone number or demand additional
            account variations which is time consuming factor.
          </p>
          <p className="fs16 t-pink-tc my-3">
            The Broker may electronically transfer delivery of confirmation,
            statements and other notices in connection with Electronic/Online
            Trading. It shall be the responsibility of the Account Holder(s) to
            review all communications sent by the Broker including E-mails,
            confirmation statements, notices, margin and Maintenance calls
            whether delivered by mail, e-mail or electronic terminals. If the
            Password/PIN is disclosed to any third party, the Account Holder(s)
            should immediately notify the same to the Broker. The Account
            Holder(s) will immediately notify the Broker of any loss, theft or
            unauthorized use of his/her/their Account number and/or
            Password/PIN. The Account Holder(s) shall immediately notify the
            Broker in writing of any change in his/her/their e-mail or other
            address as mentioned in the Account Opening Form.
          </p>
          <p className="fs16 t-pink-tc my-3">
            All risks connected and involved with Electronic/Online Trading will
            be assumed fully by the Account Holder(s). The Account Holder(s)
            acknowledges that Electronic/Online Trading may from time to time be
            adversely affected (inter alia) by network congestion, equipment
            failure, software failure, system breakdown, loss of connectivity,
            power failure, adverse market conditions, partial execution of order
            and/or other technical glitches/failures included but not limited to
            (including but not limited to connectivity failures). Neither the
            Broker nor any of its directors, its management, its branch offices,
            offices of supervisory jurisdiction and their respective registered
            representatives and employees, would be responsible or liable in any
            manner for any loss or damage that may be suffered by the Account
            Holder(s) including those due to the misuse of the Account Holder(s)
            information and affairs by unscrupulous person(s) in any manner
            whatsoever.
          </p>
          <p className="fs16 t-pink-tc my-3">
            The Broker may at any time and from time to time require additional
            margin in the Account (in cash or Securities) before executing any
            orders or undertaking any transactions through Online Trading
            facility on account of the Account Holder(s). The Amount and timing
            may vary depending on factors solely at the Broker’s discretion. The
            Broker shall have the right to liquidate the Account Holder(s)
            trading position(s) if the Account margin is insufficient at any
            time.
          </p>
          <p className="fs16 t-pink-tc my-3">
            The Broke may at its discretion elect with or without notice to
            square off the Account Holder(s) Account and make all obligations in
            the Account immediately due and payable by the Account Holder(s)
            without assigning any reason. (See Margin Disclosure Statement
            annexed hereto).
          </p>

          <div className="d-inline-flex w-100 mt">
            <h3 className="fs32 ls4 fw-800 t-grey-800">
              PROFIT ON UNUTILIZED FUNDS (OPTIONAL)
            </h3>
          </div>
          <p className="fs16 t-pink-tc my-3">
            I hereby, affirm that I will not seek any interest/mark up on any
            unutilized funds placed in my trading account maintained with Next
            Capital Limited.
          </p>
          <div className="d-inline-flex w-100 mt16">
            <h3 className="fs32 ls4 fw-800 t-grey-800">UNDERTAKING</h3>
          </div>
          <p className="fs16 t-pink-tc my-3">
            I/We, the Account Holder(s) fully understand(s) that the shares
            trading business carries risk and subject to the due diligence on
            part of the Broker. I/We may incur losses for which I/We, the
            Account Holder(s) shall not held the Broker responsible. The Account
            Holder(s) further acknowledge(s) that the prices of the Securities
            do fluctuate abruptly and instantly and investments in Securities
            may experience abrupt upward and downward movements and may even
            become valueless. The Broker shall not be liable for any
            fluctuations in the prices of Securities due to purchase and sale on
            the day of transaction and the net prices mentioned in the
            confirmation shall be accepted as concluded final price and shall be
            binding upon the Account Holder(s) and Broker.
          </p>
          <div className="d-inline-flex w-100">
            <h3 className="fs32 ls4 fw-800 t-grey-800 mt16">
              MARGIN DISCLOSURE STATEMENT
            </h3>
          </div>
          <p className="fs16 t-pink-tc my-3">
            This statement forms a part of the Account Opening Form for Online
            Trading. Next Capital Limited, also referred to herein as the Broker
            is furnishing this document to the Account Holder(s) to provide some
            facts about purchasing Securities on margin, and to alert the
            Account Holder(s) as to the risks involved with trading Securities
            in a margin account. Before trading Securities in a margin account,
            the Account Holder(s) should carefully review the margin clause in
            the Special terms and Conditions for Online trading enunciated in
            the Account Opening Form. The Account Holder(s) should obtain
            clarification(s) from the broker regarding any questions or concerns
            he/she/they may have regarding the margin account. It is important
            that the Account Holder(s) fully understand(s) the risks involved in
            trading Securities on margin. These risks include the following:
          </p>
          <div className="Bold">
            The broker can force the sale of Securities or other asset(s) in the
            Account Holder(s) account:
          </div>

          <p className="fs16 t-pink-tc my-3">
            If the equity in the Account Holder(s) account falls below the
            maintenance margin requirements, the Broker, after the margin call
            notice period, can sell the Securities or other assets in the
            account to cover the margin deficiency. The Account Holder(s) also
            shall still be liable for any shortfall in the account after such
            sale.
          </p>
          <div className="Bold">
            The Account Holder(s) can lose more funds than invested in the
            Account:
          </div>

          <p className="fs16 t-pink-tc my-3">
            A decline in the value of Securities that are purchased on margin
            may require the Account Holder(s) to provide additional funds to the
            Broker to avoid forced sale of those Securities or other Securities
            or asset(s) in the Account Holder(s) account.
          </p>

          <div className="Bold">
            Account Holder(s) are not entitled to choose which Securities or
            other assets in the account are liquidated or sold first to meet
            margin requirements:
          </div>

          <p className="fs16 t-pink-tc my-3">
            Because the Securities are collateral for margin trading, the Broker
            has the right to decide which Security(ies) to sell in order to
            protect its interests and/or meet margin requirements.
          </p>
          <div className="Bold">
            The Broker can amend its “in-house” maintenance margin requirements
            at any time and is required to provide the Account Holder(s) 7
            (seven) days advance written notice:
          </div>
          <p className="fs16 t-pink-tc my-3">
            These changes in Broker’s policy often take place immediately and
            may result in the issuance of maintenance margin call. The Account
            Holder(s) failure to satisfy the call may cause the Broker to
            liquidate or sell Securities in his/her/their Account.
          </p>
          <div className="Bold">
            The Account Holder(s) are not entitled to an extension of time on
            margin call:
          </div>
          <p className="fs16 t-pink-tc my-3">
            While an extension of time to meet margin requirements may be
            available to Account Holder(s) under certain conditions, the Account
            Holder(s) does not/do not have a right to the extension.
          </p>

          <div className="d-inline-flex w-100">
            <h3 className="fs32 ls4 fw-800 t-grey-800">CASH DEALING</h3>
          </div>

          <p className="fs16 t-pink-tc my-3">
            All valued clients are requested to note that Next Capital Limited
            do not deal with cash. Further Next capital, its employees, or
            branches are not authorized to collect cash or cheque or any other
            instrument which is not in favor of Next Capital Limited.
          </p>
          <p className="fs16 t-pink-tc my-3">
            Clients are requested to deposit payment in dedicated account
            numbers of Next Capital Limited given to them at the time of account
            opening.
          </p>
          <p className="fs16 t-pink-tc mt28 txtcenter">OR </p>

          <p className="fs16 t-pink-tc  mt28">
            Issue cross cheque in favor of Next Capital Limited.
          </p>
          <p className="fs16 t-pink-tc my-3">
            Next Capital Limited do not take the responsibility of any financial
            loss if client ignore this guideline.
          </p>
        </div>

        <form onSubmit={handleAccpet} className="" id="AOF-form">
          <hr className="t-grey-200 mt-40"></hr>
          <div className="mb-3 mt-40 row w-100">
            <div className="col-md-8 mb-3">
              <div>
                <div className="col-sm-9 col-md-10 my-auto px-3 d-flex">
                  <input
                    className="form-check-input me-2 mb-3"
                    type="checkbox"
                    defaultChecked={values.Accepted}
                    onChange={handleChange}
                    name="Accepted"
                    id="Accepted"
                  />
                  <label
                    className="form-check-label fw-500 fs16"
                    htmlFor="Accepted"
                  >
                    Yes, I accept the Terms & Condition.
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-4 text-end Half2">
              <button
                className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn text-nowrap"
                type="button"
                onClick={() => handleBackBtn()}
              >
                Back
              </button>

              <button
                className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn disabledbutton"
                type="submit"
                id="TermsCondition"
                disabled={!values.Accepted}
                // onClick={() => handleAccpet()}
              >
                Accept
              </button>
            </div>
          </div>
        </form>
        <hr className="t-grey-200 mt mb"></hr>
        <Disclaimer />
        <p className="text-danger fs12 text-end">{error}</p>
      </div>

      <div className="modal" tabIndex="-1" role="dialog" id="SaveExitModal">
        <div className="modal-dialog centerr" role="document">
          <div className="modal-content">
            <div className="modal-header p-0">
              <h5 className="modal-title t-pink">Information Submited</h5>

              <span className="close cross">&times;</span>
            </div>
            <div className="modal-body px-0">
              <p className="fw-500 fs16 ms-auto t-pink-tc cursorPointer">
                Thank You your information has been saved.
              </p>
            </div>
            <div className="modal-footer px-0">
              <NavLink to="/Dashboard">
                <button
                  type="button"
                  className="btn-outlined fs16 px-3 py-2 mx-2 close"
                  data-dismiss="modal"
                >
                  OK
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermAndConditions;
